import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataChecklist } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_CHECKLIST = defineMasterdataEntity<MasterdataChecklist>({
  name: 'checklist',
  responseKey: 'checklists',
  displayWith: (c) => keyName(c.key, c.name),
  defaultFilter: ACTIVE_ONLY,
  icon: 'fa-regular fa-list-check',
  title: 'Checklistensuche',
  label: 'Checkliste',
  placeholder: 'Checkliste suchen...',
  columns: [
    {
      label: 'Checkliste',
      type: 'entity',
      icon: 'fa-regular fa-list-check',
      value: (c) => keyName(c.key, c.name),
    },
    { label: 'Schlüssel', value: (c) => c.key },
    { label: 'Bezeichnung', value: (c) => c.name },
    { label: 'Aktiv', value: (c) => (c.active ? 'Ja' : 'Nein') },
  ],
});
